<template>
  <a-config-provider :locale="locale">
    <a-time-picker
      v-model:value="time"
      :placeholder="placeholder"
      @change="handleChangeTime"
      :disabled="disabled"
      :format="format"
      :show-hour="format == 'hh' || showHour"
      :show-minute="format == 'mm' || showMinute"
      :show-second="format == 'ss' || showSecond"
      :show-now="showNow"
      :popupClassName="'custom-dropdown'"
      class="time-picker-type"
      :popupStyle="{ width: '120px' }"
    />
  </a-config-provider>
</template>

<script setup lang="ts">
import locale from "ant-design-vue/es/locale/en_US";
import { ref, watch } from "vue";
import dayjs from "dayjs";

const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showHour: {
    type: Boolean,
    default: false,
  },
  showMinute: {
    type: Boolean,
    default: false,
  },
  showSecond: {
    type: Boolean,
    default: false,
  },
  showNow: {
    type: Boolean,
    default: true,
  },
  format: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: "Seleccionar tiempo",
  },
});

const time = ref<dayjs.Dayjs | string | null>(null);

const emit = defineEmits(["update:value"]);

const handleChangeTime = (value: dayjs.Dayjs | null) => {
  let newValue;
  console.log(value, 'handle change time');
  if (value) {
    switch (props.format) {
      case "ss":
        newValue = value.second();
        break;
      case "mm":
        newValue = value.minute();
        break;
      case "hh":
        newValue = value.hour();
        break;
      default:
        newValue = value;
        break;
    }
  } else {
    newValue = null; // Manejar caso nulo
  }
  emit("update:value", newValue);
};

const secondsToDayjs = (seconds: number): dayjs.Dayjs => {
  return dayjs().startOf('day').add(seconds, 'second');
};

const minutesToDayjs = (minutes: number): dayjs.Dayjs => {
  return dayjs().startOf('day').add(minutes, 'minute');
};

const hoursToDayjs = (hours: number): dayjs.Dayjs => {
  return dayjs().startOf('day').add(hours, 'hour');
};

watch(
  () => props.value,
  (newVal) => {
    console.log(newVal, 'new val');
    switch (props.format) {
      case "ss":
        time.value = secondsToDayjs(Number(newVal));
        console.log(time.value, 'time value');
        break;
      case "mm":
        time.value = minutesToDayjs(Number(newVal));
        break;
      case "hh":
        time.value = hoursToDayjs(Number(newVal));
        break;
      default:
        time.value = newVal;
        break;
    }
    console.log(time.value, 'time value');
  },
  { immediate: true }
);
</script>

<style scoped lang="sass">
:global(.custom-dropdown .ant-picker-panel),
:global(.custom-dropdown .ant-picker-ok),
:global(.custom-dropdown .ant-btn),
:global(.custom-dropdown .ant-picker-time-panel-cell-inner)
  width: 100% !important

.ant-picker.time-picker-type
  width: 100% !important
</style>
